<template>
  <div>
    <div class="btn shadow-sm w-auto mr-2 overflow-hidden" @click="clickAddToGroup">
      <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg"
           xmlns:xlink="http://www.w3.org/1999/xlink">
        <g id="Page-2" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g id="add_24">
            <rect id="Bounds" x="0" y="0" width="24" height="24"></rect>
            <path
                d="M13.000006,11 L19.5,11 C20.0522847,11 20.5,11.4477153 20.5,12 C20.5,12.5522847 20.0522847,13 19.5,13 L13.000006,13 L13.000006,19.500084 C13.000006,20.0523464 12.5523089,20.5000435 12.0000465,20.5000435 C12.000032,20.5000435 12.0000175,20.5000435 12.000003,20.5000435 C11.4477096,20.5000195 11,20.0522904 11,19.499997 L11,13 L4.5,13 C3.94771525,13 3.5,12.5522847 3.5,12 C3.5,11.4477153 3.94771525,11 4.5,11 L11,11 L11,4.50000301 C11,3.9477166 11.4477166,3.5 12.000003,3.5 C12.5522894,3.5 13.000006,3.9477166 13.000006,4.50000301 L13.000006,11 Z"
                id="Mask" fill="currentColor"></path>
          </g>
        </g>
      </svg>
      <span class="btn__text-xs">В сообщество</span>
      <span class="btn__text-sm">Добавить в сообщество</span>
    </div>
  </div>
</template>

<script>
import bridge from "@vkontakte/vk-bridge";
import {store} from "@/store";

export default {
  name: "AddCommunityButton",
  data() {
    return {
      result: null
    }
  },
  methods: {
    clickAddToGroup() {
      bridge.send("VKWebAppAddToCommunity").then(() => {
        this.result = true;

        store.commit("addCommunityButton", {
          result: true,
          message: "Приложение установлено в сообщество!",
        });

      }).catch((e) => {
        // User denied
        if (e.error_data.error_code !== 4) {
          this.result = false;
          store.commit("addCommunityButton", {
            result: false,
            message: "Ошибка добавления в сообщество!",
          });
        }
      }).finally(() => {
        setTimeout(() => {
          this.result = null;
          store.commit("addCommunityButton", {
            result: null,
            message: "",
          });
        }, 3000);
      });
    },
  }
}
</script>


<style lang="scss" scoped>
@import "../../scss/partials/buttons";

.btn {
  @extend .btn-share;
  border-radius: 5px;
  height: 36px;
}

.message {
  text-align: center;
  margin-top: 14px;

  & svg {
    fill: var(--zodiac-svg-fill);
  }
}

.message__text {
  color: var(--default-text-color);
}

.btn__text-xs {
  @media screen and (min-width: 321px) {
    display: none;
  }
}

.btn__text-sm {
  @media screen and (max-width: 320px) {
    display: none;
  }
}
</style>